import React from 'react';

import './tyopaikat.m.css';

const Tyopaikat = () =>
<div styleName="rekry-ads">
  <iframe title="rekrytointi.com" rel="dns-prefetch" src="https://rekryboksi-v4.appspot.com/v4/ilkka-pohjalainen/index.html" height="600" scrolling="no" width="300" frameBorder="0" border="0"></iframe>
  <a styleName="tyopaikat" href="/ilkkapohjalainen/tyopaikat-etela-pohjanmaa">Työpaikat Etelä-Pohjanmaa</a>
  <a styleName="tyopaikat" href="/ilkkapohjalainen/tyopaikat-pohjanmaa">Työpaikat Pohjanmaa</a>
</div>
export {Tyopaikat}
